import styled from 'styled-components';

export const StyledNotificationDropdownList = styled('div')`
  padding: ${props => props.padding || `0px`};
`
